const middleware = {}

middleware['browserIncompatible'] = require('../middleware/browserIncompatible.js')
middleware['browserIncompatible'] = middleware['browserIncompatible'].default || middleware['browserIncompatible']

export default middleware
